/**
 * Override Shopify Forms Shadow Root Styles
 * Only color and border-radius overrides to match WECK brand
 */

const BRAND_COLORS = {
  gurke: '#255a2e',
  aubergine: '#421d25',
  erdbeere: '#e83a43',
  erbse: '#5c8b2f',
  white: '#fff',
  kiwi: '#cbd862',
  gray: '#5C5F62',
};

const customStyles = `
  /* Remove all border-radius */
  * {
    border-radius: 0 !important;
  }

  /* Color Overrides - Input text */
  ._formInputField_nag3b_7,
  ._formPhoneInputField_piv1u_17,
  ._textArea_17mgw_1,
  ._selectToggle_12thd_25 {
    color: ${BRAND_COLORS.aubergine} !important;
  }

  /* Color Overrides - Labels */
  ._formInputFieldLabel_1mxsl_38,
  ._label_12thd_10,
  ._radioLegend_nw6va_18,
  ._birthdayText_rzr7e_15 {
  }

  /* Color Overrides - Containers background */
  ._formFieldContainer_1mxsl_5,
  ._selectContainer_12thd_6,
  ._radioFieldSet_nw6va_1,
  ._consentCheckboxContainer_cit2d_49,
  ._formFileInput_ehvsf_1,
  [class*="_dropdown_"] {
    background-color: ${BRAND_COLORS.white} !important;
  }

  /* Remove background from textarea container ::before */
  ._formFieldContainer_1mxsl_5:has(textarea)::before {
    background-color: transparent !important;
  }

  /* Color Overrides - Focus states */
  ._formFieldContainer_1mxsl_5:focus-within,
  ._selectContainer_12thd_6:focus-within,
  ._radioFieldSet_nw6va_1:focus-within {
  }

  /* Color Overrides - Radio and Checkbox */
  ._radioInput_nw6va_31,
  ._checkboxInput_1hja3_38 {
  }

  ._radioField_nw6va_1,
  ._checkboxField_1hja3_3 {
    color: ${BRAND_COLORS.aubergine} !important;
  }

  /* Color Overrides - Submit Button */
  ._formSubmitButton_cit2d_96 {
    background-color: ${BRAND_COLORS.gurke} !important;
    color: ${BRAND_COLORS.white} !important;
  }

  ._formSubmitButton_cit2d_96:hover:not([aria-disabled="true"]) {
    background-color: ${BRAND_COLORS.aubergine} !important;
  }

  /* Color Overrides - File Upload Button */
  ._formFileInputButton_ehvsf_18 {
    background-color: ${BRAND_COLORS.gurke} !important;
    color: ${BRAND_COLORS.white} !important;
  }

  ._formFileInputButton_ehvsf_18:hover {
    background-color: ${BRAND_COLORS.aubergine} !important;
  }

  /* Color Overrides - Arrow Icons */
  ._arrowDownIcon_12thd_19 svg path {
    fill: ${BRAND_COLORS.aubergine} !important;
  }

  /* Color Overrides - Dropdown options */
  [class*="_dropdownOption_"],
  [class*="_option_"] {
    color: ${BRAND_COLORS.aubergine} !important;
  }

  [class*="_dropdownOption_"]:hover,
  [class*="_option_"]:hover {
    background-color: ${BRAND_COLORS.kiwi} !important;
  }

  form._formFieldset_cit2d_82 {
    gap: 18px !important;
  }
`;

const findAndStyleShadowRoot = () => {
  const shopifyFormsEmbed = document.querySelector('shopify-forms-embed');

  if (!shopifyFormsEmbed || !shopifyFormsEmbed.shadowRoot) {
    return false;
  }

  const { shadowRoot } = shopifyFormsEmbed;

  // Check if styles already injected
  if (shadowRoot.querySelector('style[data-weck-override]')) {
    return true;
  }

  // Inject custom styles
  const styleElement = document.createElement('style');
  styleElement.setAttribute('data-weck-override', 'true');
  styleElement.textContent = customStyles;
  shadowRoot.appendChild(styleElement);

  return true;
};

// Initial attempt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(findAndStyleShadowRoot, 100);
  });
} else {
  setTimeout(findAndStyleShadowRoot, 100);
}

// Retry mechanism with MutationObserver
const observer = new MutationObserver(() => {
  const found = findAndStyleShadowRoot();
  if (found) {
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Fallback: retry every 500ms for up to 5 seconds
let retryCount = 0;
const maxRetries = 10;

const retryInterval = setInterval(() => {
  retryCount += 1;
  const found = findAndStyleShadowRoot();

  if (found || retryCount >= maxRetries) {
    clearInterval(retryInterval);
    if (found) {
      observer.disconnect();
    }
  }
}, 500);
